module.exports = __webpack_public_path__ + "static/img/howUseUpiEN.8b4a6cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/upiTeaching/howUseUpiEN.png
// module id = h/US
// module chunks = 0